import * as KatalMetrics from '@amzn/katal-metrics';
import { KatalMonitoringDriver } from '@amzn/katal-monitoring-aws-driver';

const metricsConsoleErrorHandler = (err: Error) => console.error(err);

const makeMetricsDriver = (): KatalMetrics.MetricsDriver => {
    return new KatalMonitoringDriver({
        url: 'https://zk1aeyp2bg.execute-api.us-west-2.amazonaws.com/prod/v1/monitoring',
    });
};

const makePublisher = (): KatalMetrics.Publisher => {
    const metricsDriver = makeMetricsDriver();
    const initialMetricsContext = new KatalMetrics.Context.Builder()
        .withSite('EagleEyePortalKatalApp')
        .withServiceName('EagleEyePortal')
        .build();
    return new KatalMetrics.Publisher(
        metricsDriver,
        metricsConsoleErrorHandler,
        initialMetricsContext);
};

const initialMetricsPublisher = makePublisher();

export default initialMetricsPublisher;

const apiMetricsPublisher = initialMetricsPublisher.newChildActionPublisherForMethod('API');
/**
 * Records an API request
 */
export const recordAPICall = (apiName: string) => {
    apiMetricsPublisher.publishCounter(`${apiName}.RequestCount`, 1);
};

/**
 * Records a successful API response with latency
 */
export const recordAPISuccess = (apiName: string, latencyMs: number) => {
    apiMetricsPublisher.publishCounter(`${apiName}.SuccessCount`, 1);
    apiMetricsPublisher.publishTimer(`${apiName}.Latency`, latencyMs);
};

/**
 * Records an API error
 */
export const recordAPIError = (apiName: string) => {
    apiMetricsPublisher.publishCounter(`${apiName}.ErrorCount`, 1);
};

